(() => {
  const cfg = window.SAPShopify || {};
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];

  const menuButton = $('[data-menu-toggle]');
  const mobilePanel = $('[data-mobile-panel]');
  const menuOverlay = $('[data-menu-overlay]');
  const menuClose = $('[data-menu-close]');
  let lastFocused = null;

  const focusables = () => mobilePanel ? $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', mobilePanel) : [];
  const openMenu = () => {
    if (!mobilePanel || !menuButton) return;
    lastFocused = document.activeElement;
    mobilePanel.classList.add('is-open');
    menuOverlay?.classList.add('is-open');
    mobilePanel.setAttribute('aria-hidden','false');
    menuButton.setAttribute('aria-expanded','true');
    document.body.classList.add('menu-open');
    (focusables()[0] || mobilePanel).focus();
  };
  const closeMenu = () => {
    if (!mobilePanel || !menuButton) return;
    mobilePanel.classList.remove('is-open');
    menuOverlay?.classList.remove('is-open');
    mobilePanel.setAttribute('aria-hidden','true');
    menuButton.setAttribute('aria-expanded','false');
    document.body.classList.remove('menu-open');
    lastFocused?.focus?.();
  };
  menuButton?.addEventListener('click', () => mobilePanel?.classList.contains('is-open') ? closeMenu() : openMenu());
  menuClose?.addEventListener('click', closeMenu);
  menuOverlay?.addEventListener('click', closeMenu);
  mobilePanel?.addEventListener('click', (e) => { if (e.target.closest('a')) closeMenu(); });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobilePanel?.classList.contains('is-open')) closeMenu();
    if (event.key === 'Tab' && mobilePanel?.classList.contains('is-open')) {
      const nodes = focusables(); if (!nodes.length) return;
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  $$('[data-product-tabs]').forEach((tabs) => {
    const buttons = $$('[role="tab"]', tabs);
    const panels = $$('[role="tabpanel"]', tabs);
    buttons.forEach((btn) => btn.addEventListener('click', () => {
      const target = btn.getAttribute('aria-controls');
      buttons.forEach((b) => { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); b.tabIndex = b === btn ? 0 : -1; });
      panels.forEach((p) => { p.hidden = p.id !== target; });
    }));
  });

  $$('[data-card-variant-select]').forEach((select) => select.addEventListener('change', () => {
    const card = select.closest('[data-product-card]');
    const option = select.selectedOptions[0];
    if (!card || !option) return;
    const price = $('[data-product-price]', card);
    const compare = $('[data-product-compare]', card);
    const badge = $('[data-sale-badge]', card);
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
    if (badge) badge.hidden = !option.dataset.compare;
  }));

  $$('[data-product-section]').forEach((section) => {
    const variantsNode = $('[data-product-variants]', section);
    if (!variantsNode) return;
    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch { return; }
    const selectors = $$('[data-option-index]', section);
    const idInput = $('[data-variant-id]', section);
    const price = $('[data-product-price]', section);
    const compare = $('[data-product-compare]', section);
    const saleBadge = $('[data-sale-badge]', section);
    const add = $('[data-add-to-cart]', section);
    const availability = $('[data-availability]', section);
    const availabilityText = $('[data-availability-text]', section);
    const sku = $('[data-sku]', section);
    const skuWrap = $('[data-sku-wrap]', section);
    const mainImage = $('[data-product-main-image]');

    const syncVariant = () => {
      const values = selectors.map((select) => select.value);
      const variant = variants.find((item) => item.options.every((opt, i) => opt === values[i])) || variants[0];
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = variant.price;
      if (compare) { compare.hidden = !variant.compare; compare.textContent = variant.compare || ''; }
      if (saleBadge) saleBadge.hidden = !variant.compare;
      if (add) { add.disabled = !variant.available; add.textContent = variant.available ? (cfg.strings?.addToCart || 'Add to cart') : (cfg.strings?.soldOut || 'Sold out'); }
      if (availability) availability.classList.toggle('is-unavailable', !variant.available);
      if (availabilityText) availabilityText.textContent = variant.available ? (cfg.strings?.inStock || 'In stock') : (cfg.strings?.soldOut || 'Sold out');
      if (skuWrap && sku) { sku.textContent = variant.sku || ''; skuWrap.hidden = !variant.sku; }
      if (variant.image && mainImage) mainImage.src = variant.image;
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
    };
    selectors.forEach((select) => select.addEventListener('change', syncVariant));
  });

  $$('[data-product-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
    const image = $('[data-product-main-image]');
    if (!image || !thumb.dataset.imageSrc) return;
    image.src = thumb.dataset.imageSrc;
    $$('[data-product-thumb]').forEach((node) => node.setAttribute('aria-current', node === thumb ? 'true' : 'false'));
  }));

  $$('[data-product-recommendations]').forEach(async (node) => {
    if (!node.dataset.url || node.dataset.loaded === 'true') return;
    node.dataset.loading = 'true';
    try {
      const response = await fetch(node.dataset.url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const replacement = doc.querySelector('[data-product-recommendations]');
      if (replacement && replacement.innerHTML.trim()) { node.innerHTML = replacement.innerHTML; node.dataset.loaded = 'true'; }
    } catch (error) { console.warn('Recommendations unavailable', error); }
    node.dataset.loading = 'false';
  });
})();